<template>
  <section class="section">
    <van-row class="section-head">
      <van-col span="22">
        <h2 class="title">{{ t('donwload.whatsNew') }}</h2>
      </van-col>
      <van-col span="2">
        <van-icon name="arrow" size="16" color="#9ca3af" />
      </van-col>
    </van-row>

    <p class="version">{{ t('appStore.whatsNewVersion') }} · {{ t('appStore.whatsNewUpdatedAt') }}</p>

    <p class="body" :class="{ clamped: !expanded }">
      {{ t('appStore.whatsNewBody') }}
      <span class="toggle" @click="expanded = !expanded">
        {{ expanded ? t('common.less') : t('common.more') }}
      </span>
    </p>
  </section>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const expanded = ref(false);
</script>

<style scoped>
.section {
  padding: 24px 16px 0;
}

.section-head {
  align-items: center;
  margin-bottom: 12px;
}

.title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: #111827;
}

.version {
  margin: 0;
  font-size: 13px;
  color: #6b7280;
}

.body {
  margin: 12px 0 0;
  font-size: 14px;
  line-height: 1.45;
  color: #1f2937;
}

.body.clamped {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.toggle {
  color: #007AFF;
  margin-left: 4px;
}
</style>
